import "./ProductCard.css";
import { Link } from "react-router-dom";
import {
    FaHeart,
    FaRegHeart,
    FaShoppingCart,
    FaEye,
    FaStar
} from "react-icons/fa";

function ProductCard({
    product,
    wishlist,
    handleWishList,
    handleToCart,
    setWishlist
}) {

    return (

        <div className="product-card">

            <div className="product-image-section">

                <button
                    className="wishlist-btn"
                    onClick={() => {

                        handleWishList(
                            product.id,
                            wishlist[product.id],
                            (val) =>
                                setWishlist(prev => ({
                                    ...prev,
                                    [product.id]: val
                                }))
                        );

                    }}
                >

                    {wishlist[product.id]
                        ? <FaHeart />
                        : <FaRegHeart />}

                </button>

                <img
                    src={product.imageUrl}
                    alt={product.name}
                    className="product-image"
                />

            </div>

            <div className="product-content">

                <h5 className="product-name">

                    {product.name}

                </h5>

                <p className="product-category">

                    {product.categories?.name}

                </p>

                <div className="rating">

                    <FaStar />

                    <span>4.8</span>

                </div>

                <h3 className="price">

                    ₹{product.price.toLocaleString()}

                </h3>

                <div className="product-actions">

                    <button
                        className="cart-btn"
                        onClick={() => handleToCart(product.id)}
                    >

                        <FaShoppingCart />

                        Add

                    </button>

                    <Link
                        to={`/product/${product.id}`}
                        className="view-btn"
                    >

                        <FaEye />

                    </Link>

                </div>

            </div>

        </div>

    );

}

export default ProductCard;